import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Alert, Box, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import Footer from './Footer'

export interface Props {
  onClose: () => void
}

const NoTemplatesFoundModal = ({ onClose }: Props) => {
  const { value: hasTemplatesEditPermission, loading: arePermissionsLoading } = useAsyncCan(
    'shift_management.create_templates'
  )

  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const onSubmit = () => navigate(navigation.shifts.templates.fullPath())

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('shift_management.actions.add_rotating_shift')}
      description={i18n.t(
        'shift_management.rotating_shifts.no_rotating_shifts_found_modal.description1'
      )}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        !arePermissionsLoading && (
          <Footer hasPermissions={hasTemplatesEditPermission} onClose={onClose} />
        )
      }
    >
      <Box gap="s16">
        <Text.Normal>
          {i18n.t('shift_management.rotating_shifts.no_rotating_shifts_found_modal.description2')}
        </Text.Normal>
        {!hasTemplatesEditPermission && (
          <Alert color="warning">
            <Text.Normal>
              {i18n.t(
                'shift_management.rotating_shifts.no_rotating_shifts_found_modal.no_permissions_alert'
              )}
            </Text.Normal>
          </Alert>
        )}
      </Box>
    </Modal>
  )
}

export default NoTemplatesFoundModal
